import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function BellOutlineIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#3B3C40';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_299_8721)'>
        <path
          d='M20.52 15.2097L18.72 13.3996V8.93965C18.744 7.28347 18.1679 5.67456 17.0981 4.40999C16.0284 3.14541 14.5372 2.31059 12.9 2.05965C11.9498 1.93452 10.9839 2.01347 10.0666 2.29123C9.14936 2.56899 8.30188 3.03917 7.58074 3.67041C6.85959 4.30165 6.28136 5.07943 5.88462 5.95184C5.48788 6.82426 5.28176 7.77126 5.28001 8.72965V13.3996L3.48001 15.2097C3.25392 15.4395 3.1006 15.7309 3.03921 16.0475C2.97783 16.364 3.01111 16.6916 3.13489 16.9893C3.25867 17.287 3.46746 17.5416 3.73516 17.7213C4.00286 17.901 4.31759 17.9978 4.64001 17.9997H8.00001V18.3397C8.04672 19.3549 8.49396 20.3101 9.24374 20.9962C9.99351 21.6822 10.9847 22.0431 12 21.9997C13.0154 22.0431 14.0065 21.6822 14.7563 20.9962C15.5061 20.3101 15.9533 19.3549 16 18.3397V17.9997H19.36C19.6824 17.9978 19.9972 17.901 20.2649 17.7213C20.5326 17.5416 20.7414 17.287 20.8651 16.9893C20.9889 16.6916 21.0222 16.364 20.9608 16.0475C20.8994 15.7309 20.7461 15.4395 20.52 15.2097ZM14 18.3397C13.9446 18.8207 13.7057 19.2617 13.3331 19.5709C12.9605 19.8802 12.483 20.0337 12 19.9997C11.517 20.0337 11.0395 19.8802 10.6669 19.5709C10.2944 19.2617 10.0555 18.8207 10 18.3397V17.9997H14V18.3397ZM5.51001 15.9997L6.69001 14.8196C6.87718 14.6336 7.02567 14.4123 7.12694 14.1686C7.2282 13.9249 7.28022 13.6636 7.28001 13.3996V8.72965C7.28056 8.05505 7.4254 7.38837 7.70481 6.77436C7.98422 6.16035 8.39174 5.6132 8.90001 5.16965C9.40143 4.71533 9.99559 4.3754 10.6414 4.17338C11.2871 3.97136 11.9691 3.91209 12.64 3.99965C13.7965 4.18743 14.8462 4.78666 15.5959 5.68703C16.3456 6.5874 16.7448 7.72829 16.72 8.89965V13.3996C16.7185 13.6629 16.7689 13.9238 16.8685 14.1675C16.968 14.4111 17.1146 14.6328 17.3 14.8196L18.49 15.9997H5.51001Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_299_8721'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
